export default {
  'userStatus.active': 'Aktif',
  'userStatus.passivated': 'Pasif',
  'userStatus.pending_invitation': 'Bekleyen Davet',
  'userStatus.unknown': 'Bilinmiyor',
  'userStatus.verification': 'Doğrulanmış',
  'userStatus.notVerification': 'Doğrulanmamış',
};
